module.exports = __webpack_public_path__ + "img/loader-modal-cupo.617ca5e6.svg";